// ============================================================
// UI 共享工具：Toast 通知 + 全局故障特效
// ============================================================

export function showToast(message, ms = 3200) {
  const host = document.getElementById("toast");
  if (!host) return;

  const el = document.createElement("div");
  el.className = "toast-item";
  el.textContent = message;
  host.appendChild(el);

  setTimeout(() => {
    el.classList.add("is-leave");
    setTimeout(() => el.remove(), 320);
  }, ms);
}

export function glitchScreen(ms = 2600) {
  document.body.classList.add("glitch-mode");
  setTimeout(() => document.body.classList.remove("glitch-mode"), ms);
}

// ============================================================
// PANZER 彩蛋特效：页面震动 + 坦克 ASCII 覆盖层（居中闪现）
// 由键盘序列 panzer / 终端命令 panzer 触发
// ============================================================

const TANK_ART = [
  "      ██████████",
  "     ████████████",
  "    ██████████████",
  "   ██████▄▄▄▄██████",
  "   ████▀▀▀▀▀▀▀▀████",
  "   ████████████████",
  "    ▀███▄▄▄▄▄▄███▀",
  "      ██      ██",
  "     ██        ██",
  "    ██          ██",
  "   ██            ██",
].join("\n");

export function tankScreen() {
  // 页面横向震动（400ms，模拟坦克落地的冲击）
  document.body.classList.add("tank-shake");
  setTimeout(() => document.body.classList.remove("tank-shake"), 420);

  // 居中闪现坦克 ASCII 覆盖层（1.6s 后自动移除）
  const tank = document.createElement("pre");
  tank.className = "tank-ascii";
  tank.setAttribute("aria-hidden", "true");
  tank.textContent = TANK_ART;
  document.body.appendChild(tank);
  setTimeout(() => tank.remove(), 1700);
}
